// src/App.js — Admin portal with transport and dispatch pages added
// ProtectedRoute now also enforces owner/team_leader role, in case a
// token from a different role ever ends up in localStorage.
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar          from './components/Sidebar';
import Login            from './pages/Login';
import Dashboard        from './pages/Dashboard';
import InvoiceDetail    from './pages/InvoiceDetail';
import Exceptions       from './pages/Exceptions';
import LiveMap          from './pages/LiveMap';
import Vouchers         from './pages/Vouchers';
import Teams            from './pages/Teams';
import Settings         from './pages/Settings';
import Transports       from './pages/Transports';
import DispatchOverview from './pages/DispatchOverview';
import Heatmap         from './pages/Heatmap';
import History        from './pages/History';
import Reports        from './pages/Reports';
import MargSync       from './pages/MargSync';

const ALLOWED_ROLES = ['owner', 'team_leader'];

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('dms_token');

  // If no token, redirect to login immediately
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Enforce role even if a token happens to be present — covers stale
  // tokens, manual localStorage edits, or role changes mid-session.
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('dms_user') || 'null');
  } catch {
    user = null;
  }
  if (!user || !ALLOWED_ROLES.includes(user.role)) {
    localStorage.removeItem('dms_token');
    localStorage.removeItem('dms_user');
    return <Navigate to="/" replace />;
  }

  // Token exists and role is allowed, render the protected content.
  // Layout is now a column: Sidebar (now a sticky top header bar) stays
  // fixed in place, and only the content below it scrolls — previously
  // this was a row (side panel + flex-1 main), which is why converting
  // Sidebar into a header alone wasn't enough on its own.
  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <Sidebar />
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"            element={<Login />} />
        <Route path="/dashboard"   element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/invoices/:id"element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
        <Route path="/exceptions"  element={<ProtectedRoute><Exceptions /></ProtectedRoute>} />
        <Route path="/deliveries"  element={<ProtectedRoute><LiveMap /></ProtectedRoute>} />
        <Route path="/vouchers"    element={<ProtectedRoute><Vouchers /></ProtectedRoute>} />
        <Route path="/teams"       element={<ProtectedRoute><Teams /></ProtectedRoute>} />
        <Route path="/settings"    element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/transports"  element={<ProtectedRoute><Transports /></ProtectedRoute>} />
        <Route path="/dispatch"    element={<ProtectedRoute><DispatchOverview /></ProtectedRoute>} />
        <Route path="/heatmap"     element={<ProtectedRoute><Heatmap /></ProtectedRoute>} />
        <Route path="/history"     element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/reports"     element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/marg-sync"   element={<ProtectedRoute><MargSync /></ProtectedRoute>} />
        <Route path="*"            element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
